<template>
<v-card style="width:1400px">
<v-toolbar flat height="42">
<v-toolbar-title>
Сообщения задания - со
</v-toolbar-title>
<v-spacer></v-spacer>
<v-icon @click="groups.modals.msg = false">mdi-close</v-icon>
</v-toolbar>

<v-card-text >
<v-layout justify-center style="min-height:100vh">
<messages v-if="start" :init="init"></messages>
</v-layout>
</v-card-text>

</v-card>
</template>

<script>
import messages from '../../proc/msg/msg.vue'
import axios from 'axios'
export default {
props:['groups'],
components:{messages},
data () {
return {
start:false,
init: {
type: 'getByGroupWithOffset',
limit: 5,
offset:0,
grId: 1,
},
}
},
methods:{


},
created(){
this.init.grId = this.groups.msgItem.id_of_group
this.start = true
},

}
</script>
